module.exports = __webpack_public_path__ + "img/android-election-list.8257d310.png";